import * as React from "react";
import {useState, useEffect, createContext} from "react"
import QuoteCalculatorDashboard from "../quote_calculator/Dashboard"
import QuoteCalculatorNew from "../quote_calculator/QuoteCalculatorNew"
import QuoteCalculatorEdit from "../quote_calculator/QuoteCalculatorEdit"
import QuoteWrapper from "../quote_calculator/QuoteWrapper"
import QuotesIndex from "../quote_calculator/QuotesIndex"
import QuoteCalculatorOrder from "../quote_calculator/QuoteCalculatorOrder";
import { normalizeUserContextData } from "../../libs/user_context"
import { DashboardProvider } from "../../hooks/useDashboard"
import { QuoteProvider  } from "../../hooks/useQuote";
import {
  BrowserRouter as Router,
  Switch, 
  Route
} from "react-router-dom"

interface IProps {
  rawUserContext:any;
  cwSet:boolean;
}

function QuoteCalculator(props:IProps){
  const event = new Event('quote_change');
  useEffect(() => {
    window.document.dispatchEvent(event);
  }, [])

  const [userContext] = useState(normalizeUserContextData(props.rawUserContext));
  return (
    <div className="quote-calculator-root">
      <Router>
        <Switch>
          <Route path="/quote_calculator/new">
            <QuoteCalculatorNew userContext={userContext} />
          </Route>
          <Route path="/quote_calculator/edit/:calculator_id">
            <QuoteCalculatorEdit userContext={userContext} />
          </Route>
          <Route path="/quote_calculator/order/:calculator_id">
            <QuoteCalculatorOrder userContext={userContext} />
          </Route>
          <Route path="/quote_calculator/:calculator_id/quotes">
            <QuotesIndex userContext={userContext}/>
          </Route>
          <Route path="/quote_calculator/:calculator_id/quote_edit/:quote_id/">
            <QuoteProvider>
              <QuoteWrapper userContext={userContext} subtype="edit" cw_set={props.cwSet} />
            </QuoteProvider>
          </Route>    
          <Route path="/quote_calculator/:calculator_id/quote_show/:quote_id/">
            <QuoteProvider>
              <QuoteWrapper userContext={userContext} subtype="show" cw_set={props.cwSet} />
            </QuoteProvider>   
          </Route>                
          <Route path="/quote_calculator/:calculator_id/quote_new/">
            <QuoteProvider>
              <QuoteWrapper userContext={userContext} subtype="new" cw_set={props.cwSet} />
            </QuoteProvider>
          </Route>                             
          <Route path="/quote_calculator">
            <DashboardProvider>
              <QuoteCalculatorDashboard userContext={userContext}/>
            </DashboardProvider>
          </Route>
        </Switch>
      </Router>
    </div>
  )
}


export default QuoteCalculator


// WEBPACK FOOTER //
// ./app/javascript/components/pages/QuoteCalculator.tsx